module.exports = __webpack_public_path__ + "static/media/et_ru.89274f73.png";